import { DocLayout } from './DocLayout';

export default function DocUtilizatori() {
  return (
    <DocLayout title="Utilizatori">
      <h2>Prezentare generală</h2>
      <p>
        Pagina de utilizatori permite superadminilor să gestioneze conturile staff și să invite noi membri.
      </p>

      <h2>Lista utilizatori</h2>
      <p>Tabelul afișează toți utilizatorii staff. Poți căuta și vezi:</p>
      <ul>
        <li><strong>Nume și email</strong> — identitatea utilizatorului.</li>
        <li><strong>Echipe</strong> — badge-uri colorate cu echipele din care face parte.</li>
        <li><strong>Prieteni</strong> — organizațiile la care are acces ca prieten.</li>
        <li><strong>Roluri</strong> — Staff, Superadmin.</li>
        <li><strong>Data înregistrării</strong> — când a fost creat contul.</li>
      </ul>

      <h2>Creare utilizator</h2>
      <p>La crearea unui nou utilizator, se completează:</p>
      <ul>
        <li><strong>Email</strong> — adresa de email (obligatorie, devine și username-ul).</li>
        <li><strong>Nume și prenume</strong> — informații de identificare.</li>
        <li><strong>Parolă</strong> — parola inițială. Utilizatorul primește un email de bun venit cu link de setare a parolei.</li>
        <li><strong>Staff</strong> — marchează utilizatorul ca membru staff.</li>
        <li><strong>Superadmin</strong> — oferă acces complet la platformă.</li>
        <li><strong>Echipe</strong> — asociază cu una sau mai multe echipe.</li>
        <li><strong>Prieteni</strong> — asociază cu organizații prietene (pentru utilizatori prieten).</li>
        <li><strong>Data nașterii</strong> — opțional.</li>
      </ul>

      <h2>Rolul de voluntar</h2>
      <ul>
        <li><strong>Toggle voluntar</strong> — activează/dezactivează rolul direct din acțiunile tabelului.</li>
        <li><strong>Toggle în formular</strong> — câmpul „Voluntar" din formularul de editare al utilizatorului.</li>
        <li><strong>Auto-activare</strong> — utilizatorii marcați ca staff primesc automat rolul de voluntar dacă au data nașterii completată și cel puțin 15 ani.</li>
        <li><strong>Cereri voluntariat</strong> — utilizatorii publici pot solicita rolul. Filtrează cu „Cereri voluntariat" din dropdown-ul de roluri pentru a vedea cererile.</li>
        <li><strong>Aprobare/Respingere cereri</strong> — butoane directe în coloana de acțiuni pentru utilizatorii cu cerere activă.</li>
      </ul>
      <p>
        <strong>Condiții:</strong> Data nașterii trebuie completată și utilizatorul trebuie să aibă cel puțin 15 ani.
      </p>

      <h2>Filtrare</h2>
      <ul>
        <li><strong>Căutare</strong> — după nume, email, telefon.</li>
        <li><strong>Roluri</strong> — Staff, Superadmin, Voluntar, Cereri voluntariat, Prieten.</li>
      </ul>

      <h2>Editare și ștergere</h2>
      <p>
        Poți modifica orice câmp al unui utilizator existent sau șterge contul (cu confirmare).
        Ștergerea unui utilizator nu afectează înregistrările la activități existente.
      </p>
    </DocLayout>
  );
}
